import type { AccHub } from "./types";

/** First hub where Vera's APS app is provisioned (list is sorted provisioned-first). */
export function pickDefaultAccHub(hubs: AccHub[]): AccHub | null {
  return hubs.find(h => h.dmProvisioned === true) ?? null;
}

export function isAccHubSelectable(hub: AccHub): boolean {
  return hub.dmProvisioned === true;
}
